import { useEffect, useState } from 'react';
import './FeedHorizontalScroll.css'
import axios from 'axios'
import { API_BASE_URL } from '../../utils';
import { Link } from 'react-router-dom';


const url = `${API_BASE_URL}/master/assets/uploads/`;

export default function FeedHorizontalScroll() {

    const [data, setData] = useState([]);
    useEffect(() => {
        axios
            .get("https://partywitty.com/master/APIs/Common/getAllPackageTitle")
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => console.log(error));
    }, []);


    function generateClubUrl(packagetype) {
        const format = (str) => (str ? str.trim().replace(/\s+/g, "-").toLowerCase() : "");

        return `/party-packages-${format(packagetype)}`;
    }


    return (
        <>
            <div className='FeedHorizontalScroll-section'>
                <div className='FeedHorizontalScroll-container'>
                    <div className='FeedHorizontalScroll-content'>
                        {data.map((item) => (
                            <Link
                                to={generateClubUrl(item?.name)}
                                key={item?.id}
                            >
                                <div className='FeedHorizontalScroll-card'>
                                    <div className='FeedHorizontalScroll-card-img'>
                                        <img src={url + item?.img} alt="" />
                                        <div className='FeedHorizontalScroll-card-img-overlay'>
                                            <p>{item?.name.length > 25 ? item.name.slice(0, 25) + "..." : item?.name}</p>
                                            <span>&#40;{item?.total_packages}&#43;&#41;</span>
                                        </div>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}
